export const iconImg = (id: string) =>
  `/assets/tft/synergies/${id}.svg`;
export const championImg = (id: string) =>
  `/assets/tft/champions/${id}.png`;
